import { Link } from "react-router-dom";
import BaseCom from "../../components/BaseCom";
import AppActions from "../../components/Solusek/AppActions";
import DataView from "../../components/Solusek/DataView";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import Icon from "../../components/Icon";
import L from "../../components/Lang";
import { Modal } from "react-bootstrap";
import FormInputV2 from "../../components/FormInputV2";
import { qreq } from "../../shared/qrequest";
import { Pop, PopModal } from "../../components/PopModal";

class APIKeyManager extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                reqIPFilters: []
            } //schema
        };
    }

    async componentDidMount() {
        await this.fillListAsync('/api/api-client/list', 'clients');
    }

    submit = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        let item = { ...this.state.item };

        let err = false;
        item.reqIPFilters.forEach(i => {
            if(!this.ipv4Valid(i.ipStr)) {
                this.alert(`IP address ${i.ipStr} is malformated.`);
                err = true;
            }
        });

        if(err) return;

        item.apiClientID = parseInt(item.apiClientID);
        try {
            let j = await qreq.postAsync('/api/api-credential/new', item);
            if (j.item) {
                this.setState({ newItem: j.item });
                this.rehash();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    remove = (item) => {
        Pop.showConfirm(<L>Remove API Credential</L>, <L>Are you sure you want to remove API credential <strong>{item.name}</strong>?</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/api-credential/remove', item);
                if (j.errorCode === 0) {
                    this.success(<L>Deleted API credentials.</L>);
                    this.rehash();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    addAPICredentials = () => {
        this.setState({
            showNew: true, item: { //schema
                reqIPFilters: []
            }, newItem: null
        });
    }

    addReqIPFilter = () => {
        let item = { ...this.state.item };
        item.reqIPFilters.push({});
        this.setState({ item });
    }

    removeReqIPFilter = (i) => {
        let item = { ...this.state.item };
        item.reqIPFilters.splice(item.reqIPFilters.indexOf(i), 1);
        this.setState({ item });
    }

    ipv4Valid = (ipStr) => {
        const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
        return ipv4Regex.test(ipStr);
    }

    render() {
        return (
            <div className="container-fluid">

                <Modal show={this.state.showNew} onHide={() => this.setState({ showNew: false })} size="lg"
                    backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Create Credentials</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={this.submit}>
                        <Modal.Body>
                            {this.state.newItem ? <div>
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr><td width="20%"><strong>API Key</strong></td><td>{this.state.newItem.apiKey}</td></tr>
                                        <tr><td width="20%"><strong>API Secret</strong></td><td>{this.state.newItem.apiSecret}</td></tr>
                                    </tbody>
                                </table>
                                {this.state.item.reqIPFilters?.length !== 0 && <div className="mb-2">
                                    <label className="form-label">IP Filters</label>
                                    <ul className="list-group">
                                        {this.state.item.reqIPFilters?.map((i, idx) => <li key={idx} className="list-group-item">{i.ipStr}</li>)}
                                    </ul>
                                </div>}
                                <p>The <strong>API Secret</strong> is only shown once. So please save these credentials.</p>
                            </div> : <div>
                                <FormInputV2 model={this.state.item} name="apiClientID" label="Instance" required type="select" options={this.state.clients} />
                                <FormInputV2 model={this.state.item} name="name" label="Application Name" required />

                                {this.state.item.reqIPFilters?.length !== 0 && <div>
                                    <label className="form-label">IP Filters</label>
                                    {this.state.item.reqIPFilters?.map((i, idx) => <div key={idx} className="d-flex">
                                        <div className="flex-fill">
                                            <FormInputV2 model={i} name="ipStr" required placeholder="0.0.0.0" />
                                        </div>
                                        <div>
                                            <button type="button" className="btn btn-danger" onClick={() => this.removeReqIPFilter(i)}>
                                                <Icon icon="faTrash" />
                                            </button>
                                        </div>
                                    </div>)}
                                </div>}

                                <button type="button" className="btn btn-secondary" onClick={this.addReqIPFilter}>
                                    <Icon icon="faAdd" /><L>Add Request IP Filter</L>
                                </button>
                            </div>}
                        </Modal.Body>
                        <Modal.Footer>
                            {this.state.newItem ? <div>
                                <button type="button" className="btn btn-primary" onClick={() => this.setState({ showNew: false })}>
                                    <L>Confirm and Close</L>
                                </button>
                            </div> : <div>
                                <button type="submit" className="btn btn-success">
                                    <L>Create</L>
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showNew: false })}>
                                    <L>Cancel</L>
                                </button>
                            </div>}
                        </Modal.Footer>
                    </form>
                </Modal>


                <h1><L>API Credentials</L></h1>
                <DataView api={'/api/api-credential/list'} hash={this.state.hash} actions={[
                    {
                        label: <Icon icon="faTrash" />,
                        danger: true,
                        onClick: this.remove
                    }
                ]} />
                <AppActions>
                    <button type="button" className="btn btn-lg btn-primary" onClick={this.addAPICredentials}>
                        <Icon icon="faPlus" /> <L>New API Credentials</L>
                    </button>
                </AppActions>
            </div>
        )
    }
}

export default withParamsAndNavigate(APIKeyManager);